import Container from '@ui/container/container';
import { ICONS } from '@ui/icons/types';
import { EPermissions } from '@/types/permissions.types';
import useHasPermission from '@/utils/authentication/use-has-permission';
import OptionalComponent from '@ui/optional-component/optional-component';
import Icon from '@ui/icons/icon';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import { TButtonAndLinkDesigns } from '@styles/design-system/local-components/local-components.types';

type TAudiencesUploadButtonProps = {
  onAddClick?: () => void;
  canEdit?: boolean;
};

const AudiencesUploadButton = ({ onAddClick, canEdit = true }: TAudiencesUploadButtonProps) => {
  const { hasPermission } = useHasPermission({
    allowedRoles: [EPermissions.GroupAdmin],
  });

  return (
    <Container data-component="UploadAudienceButton" className="flex ai-center jc-flex-end gap-1">
      <OptionalComponent display={hasPermission && canEdit}>
        <Button
          height="32px"
          padding="0 16px"
          clear
          className="flex ai-center jc-center"
          borderRadius="100px"
          onClick={onAddClick}
          design={TButtonAndLinkDesigns.LocalBttnSec}
        >
          <div className="flex ai-center jc-center gap-8">
            <Icon name={ICONS.UPLOAD_V2} size={16} />
            <Text className="L1">Upload</Text>
          </div>
        </Button>
      </OptionalComponent>
    </Container>
  );
};

export default AudiencesUploadButton;
